module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/NB线AA站设备.d34592e6.png";